import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRenditionFilterProfiles extends Layout {
    sourceRenditionFilterProfiles: DataSource;
    sourceRenditionFilterProfs: DataSource;
    tbFiltDesc: Textbox;
    tbFiltExprsn: Textbox;
    tbFiltId: Textbox;
    tbOperators: Textbox;
    tbVariables: Textbox;
    textboxFiltDesc: Textbox;
    textboxFiltExprsn: Textbox;
    textboxFiltId: Textbox;
}
